import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appScrollRetainer]',
})
export class ScrollRetainerDirective implements AfterViewInit, OnDestroy {
  private matTabGroupEl: HTMLElement = this.el.nativeElement;
  private animationSub = Subscription.EMPTY;

  constructor(private matTabGroup: MatTabGroup, private el: ElementRef) {}

  public ngAfterViewInit(): void {
    const orig = this.matTabGroup._handleClick.bind(this.matTabGroup);
    this.matTabGroup._handleClick = (tab, tabHeader, index) => {
      if (!tab.disabled) {
        this.matTabGroupEl.style.minHeight = this.matTabGroupEl.clientHeight + 'px';
      }

      return orig(tab, tabHeader, index);
    };
    this.animationSub = this.matTabGroup.animationDone.subscribe(() => {
      this.matTabGroupEl.style.minHeight = 'unset';
    });
  }

  public ngOnDestroy() {
    this.animationSub.unsubscribe();
  }
}
